export default __webpack_public_path__ + "static/media/Cambrya_Logo.a348caf3.png";